import {
  SET_USER_CALENDAR_ENTRIES,
  SET_COMPANY_CALENDAR_ENTRIES
} from '../actions/types';

const initialState = {
  user: [],
  company: []
}

export function calendarEntry(state = initialState, action = {}) {
  switch (action.type) {
    case SET_USER_CALENDAR_ENTRIES:
      return Object.assign({}, state, { user: action.entries });
    case SET_COMPANY_CALENDAR_ENTRIES:
      return Object.assign({}, state, { company: action.entries });
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/calendar-entry.js